import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ViewHomeLogItem, SituAnalyticsWebApiClient, ListViewHomeLogItemsRequest,
  CreateViewHomeLogItemsCsvReportRequest, IsReportReadyRequest, CreateLegacyMonthlyCsvReportRequest, IsReportReadyResponse, ListRecipeEventSummariesRequest, ProductName, ListRecipeEventSummariesResponse, RecipeEventSummary
} from 'situanalytics-webapi-client';
import * as moment from 'moment';
import { PageEvent } from '@angular/material/paginator';
import { takeWhile, mergeMap } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DownloadReportDialogComponent } from '../../../components/download-report-dialog/download-report-dialog.component';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { Moment } from 'moment';
import { Company } from 'identity-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'facade-report',
  templateUrl: './facade-report.component.html',
  styleUrls: ['./facade-report.component.less'],
})
export class FacadeReportComponent extends SituBaseComponent {
  pageNumber = 1;
  pageSize = 25;
  totalItems = 0;
  logItems: RecipeEventSummary[] = [];
  reportId: string | undefined = undefined;
  isReportReady = false;
  reportErrorCount = 0;
  reportPollCount = 0;

  displayedColumns: string[] = [
    'dateStart',
    'dateEnd',
    'clientIp',
    'type',
    'configuration',
    'room',
    'renderIp',
    'wait',
    'total',
    'result',
  ];

  search: string = '';
  dateFrom: Date;
  dateTo: Date;
  clientIp: string = '';
  type = '';
  size: number | undefined = undefined;
  home: string = '';
  room: string = '';
  masterFile: string = '';
  themes: string = '';
  options: string = '';
  wait: number | undefined = undefined;
  total: number | undefined = undefined;
  result = '';

  pollForReportStatusSub: Subscription | null = null;

  private _loading = false;
  public get loading(): boolean { return this._loading; }
  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situAnalyticsCLient: SituAnalyticsWebApiClient,
    public dialog: MatDialog,
    private breadcrumbService: BreadcrumbService) {
      super(authService, stateService);
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      this.dateFrom = yesterday;
      this.dateTo = now;
  }

  protected onSelectedCompanyChange(): void {
    this.loadData();
  }

  onPageChange(evt: PageEvent) {
    this.pageSize = evt.pageSize;
    this.pageNumber = evt.pageIndex + 1;
    this.loadData();
  }

  loadData() {
    this.loading = true;

    this.dateFrom.setHours(0, 0, 0, 0);
    this.dateTo.setHours(23, 59, 59, 999);

    const dateFrom = this.dateFrom;
    const dateTo = this.dateTo;

    const request = new ListRecipeEventSummariesRequest();
    request.companyId = this.selectedCompany?.id;
    request.productName = ProductName.Facade;

    this.situAnalyticsCLient.listRecipeEventSummaries(request)
      .then((response: ListRecipeEventSummariesResponse) => {
        if (response.success) {
          this.logItems = response.items ?? [];
        }
        
        //this.reportId = response.reportId;
        //this.pollForReportStatus();
      })
      .catch((err: any) => {
        this.loading = false;
      });
  }

  downloadCsv() {
    this.clearLastReport();

    this.dateFrom.setHours(0, 0, 0, 0);
    this.dateTo.setHours(23, 59, 59, 999);

    const dateFrom = this.dateFrom;
    const dateTo = this.dateTo;

    this.loading = true;

    const request = new CreateViewHomeLogItemsCsvReportRequest({
      dateFrom,
      dateTo,
      search: this.search,
      clientIp: this.clientIp,
      type: this.type,
      home: this.home,
      room: this.room,
      facade: this.masterFile,
      theme: this.themes,
      options: this.options,
      size: this.size,
      waitTimeInSeconds: this.wait,
      totalTimeInSeconds: this.total,
      result: this.result,
      ownerId: this.selectedCompany?.id
    });

    (request as any).masterFile = this.masterFile;

    // this.situAnalyticsCLient.createViewHomeLogItemsCsvReport(request)
    //   .then(response => {
    //     this.reportId = response.reportId;
    //     this.pollForReportStatus();
    //   })
    //   .catch((err: any) => {
    //     this.loading = false;
    //   });
  }

  pollForReportStatus() {
    const pollDelayMilliseconds = 2000;
    const maxPolls = (60 * 60 * 1000) / pollDelayMilliseconds; // 1 hour max;

    this.pollForReportStatusSub = interval(pollDelayMilliseconds)
      .pipe(
        mergeMap(() => this.situAnalyticsCLient.isReportReady({ id: this.reportId } as IsReportReadyRequest)
          .then((response: any) => {
            if (response.isReady === true) {
              this.isReportReady = true;
              this.loading = false;
              this.openDownloadReportDialog();
            }

            this.reportPollCount++;
            if (this.reportPollCount >= maxPolls) {
              // show timeout error
              this.loading = false;
            }

            return response;
          }, (e: any) => {
            if (this.reportErrorCount > 1) {
              this.loading = false;
              throw e;
            }

            this.reportErrorCount++;

            let response = new IsReportReadyResponse();
            response.isReady = false;

            return response;
          })),
        takeWhile(response => response.isReady === false && this.reportPollCount < maxPolls)
      )
      .subscribe();
  }

  openDownloadReportDialog() {
    this.dialog.open(DownloadReportDialogComponent, {
      data: {
        reportId: this.reportId
      }
    });
  }

  clearLastReport() {
    if (this.pollForReportStatusSub) {
      this.pollForReportStatusSub.unsubscribe();
    }

    this.isReportReady = false;
    this.reportId = '';
    this.reportErrorCount = 0;
    this.isReportReady = false;
  }
}
